import { createFileRoute, redirect } from '@tanstack/react-router';
import { isXeroEnabled } from '@/lib/feature-flags';
import { FinanceGuard } from '@/components/finance/FinanceGuard';
import { FinanceNav } from '@/components/tracking/FinanceNav';
import { FinanceComingSoon } from '@/components/tracking/FinanceComingSoon';

/**
 * /finance/budget — Budget area (F-013). Real + flag-gated route so the nav link
 * is live and typed; budget-vs-actuals lands once the Xero Budget Manager pull
 * is wired (ticket 86d43b8yg).
 *
 * NOTE: this replaces the earlier `/finance/budget` PageStub with the finance
 * nav + a coming-soon body (still behind the same flag).
 */
export const Route = createFileRoute('/finance/budget')({
  beforeLoad: () => {
    if (!isXeroEnabled()) {
      throw redirect({ to: '/finance', replace: true });
    }
  },
  component: () => (
    <FinanceGuard>
      <div className="mx-auto w-full max-w-6xl">
        <FinanceNav />
        <FinanceComingSoon
          title="Budget"
          blurb="Your Xero budget vs actuals, month by month — once the Budget Manager pull is wired on the backend."
        />
      </div>
    </FinanceGuard>
  ),
});
